import React, { memo } from 'react';
import { parseCard } from '../utils/cards';
import PlayingCardArt from '../../common/PlayingCardArt';

/**
 * Durak playing card: wire code ("10H", "QD") → the shared SVG art (`common/PlayingCardArt`, also used by Solitaire).
 * viewBox 100×140 — size it with CSS (width; height follows the 5:7 ratio). Unknown code / faceDown → card back.
 */
function PlayingCard({ code, faceDown = false, className = '', style }) {
  const card = faceDown ? null : parseCard(code);
  return <PlayingCardArt card={card} className={`dk-card-svg ${className}`} style={style} />;
}

export default memo(PlayingCard);
